
import { Component, Prop, Vue } from 'vue-property-decorator'
import ProLabel from '~/components/common/freemium/ProLabel.vue'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'
import Checkbox from '~/components/common/Checkbox.vue'

const desk = {
  1: 'Scholarship funds are paid to the Financial Aid Office on your behalf.',
  2: 'Scholarship funds are paid directly to you.',
  3: 'Prize that supports educational goals (courses, subscriptions, etc.)',
  4: 'Payment process details have not been specified by the provider.'
}

@Component({
  name: 'PaymentFilterBar',
  components: {
    ProLabel,
    ChoiceIcon,
    Checkbox
  }
})
export default class PaymentFilterBar extends Vue {
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) description!: string
  @Prop({ type: Object }) filterSpec!: object
  @Prop({ type: Boolean, required: true }) isProFeature!: boolean
  @Prop({ type: String, default: '' }) proReferer!: string
  @Prop({ required: true }) selectionOptions!: any
  @Prop({ required: true }) isPro!: boolean

  private desk = desk

  get availablePayoutMethods() {
    const methods = this.$accessor.tabList.tabList.reduce((acc: { [x: string]: string }, scholarship: Scholarship.General) => {
      const payoutMethod = scholarship.payoutMethod

      if (!payoutMethod || !payoutMethod.length) {
        acc['4'] = 'Not Stated'
        return acc
      }

      acc[payoutMethod[0].id] = payoutMethod[0].title

      return acc
    }, {})

    return Object.values(methods)
  }
}
